<script setup lang="ts">
import { ref } from "vue";
import { NLayout, NLayoutContent, NLayoutHeader, NGrid, NGi, NSwitch } from 'naive-ui'
import { augmentifyLogo } from "@/assets/utils/icons";
import LoginForm from "@/components/LoginForm.vue";

const active = ref(true)
</script>

<template>
  <n-layout>
    <n-layout-header class="header grid-container text-align-center">
      <div v-html="augmentifyLogo"></div>
    </n-layout-header>

    <n-layout-content  content-class="login-layout grid-container">
      <n-grid x-gap="12" :cols="12" item-responsive responsive="screen">

        <n-gi span="12 s:6 m:6 l:7" class="height-100 flex-center">
          <div class="image-container">
            <img class="login-image" width="100%" src="../assets/login/login-img.png"/>

            <span class="augmentify-welcome-message">
              <span>Welcome to </span>
              <span class="augmentify-text">Augmentify</span>
              <n-switch v-model:value="active" size="medium"></n-switch>
            </span>
          </div>
        </n-gi>

        <n-gi span="12 s:6 m:5 l:4" offset="m:1">
          <login-form></login-form>
        </n-gi>
      </n-grid>
    </n-layout-content>
  </n-layout>
</template>

<style lang="scss">
.forgot-password-container {
  margin-top: 10px;
  margin-bottom: 10px;
}

</style>